<template>
  <div id="app">
    <notifications class="notifications" :duration="10000" :max="6">
      <template slot="body" slot-scope="props">
        <div class="alert" :class="'alert-' + (props.item.type || 'success')">
          <div class="notification-content">
            <template v-if="props.item.title">
              <strong>{{ props.item.title }}</strong>
              <br />
            </template>
            <span v-html="props.item.text"></span>
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click="props.close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
    </notifications>

    <Navbar v-if="isAuthenticated" />

    <div class="content" :class="containerClass">
      <router-view />
    </div>

    <footer>
      <div class="container">
        <div v-if="isLocal">
          <ul class="nav">
            <li class="nav-item">
              <router-link class="nav-link" to="/form/A/no-token/no-auth?noCheck=true">
                Form A
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/form/B/no-token?noCheck=true">Form B</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/form/view/no-token?noCheck=true">
                View form data
              </router-link>
            </li>
          </ul>
        </div>
        <div class="text-muted text-center">
          &copy; {{ $t('footer.copy', { appVersion }) }}
        </div>
      </div>
    </footer>

    <DevTools />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { APP_VERSION, ENV } from '@/config';
import DevTools from '@/components/_devTools/DevTools';
import Navbar from '@/components/Navbar';

export default {
  components: {
    DevTools,
    Navbar,
  },

  computed: {
    ...mapGetters('user', ['isAuthenticated']),

    isFullWidth() {
      return this.$route.meta.fullWidth || false;
    },

    containerClass() {
      return this.isFullWidth ? ['container-fluid'] : ['container'];
    },

    isLocal() {
      return ENV.value === 'local';
    },

    appVersion() {
      return APP_VERSION === '0.0.0' ? 'local-dev' : APP_VERSION;
    },
  },
};
</script>

<style lang="scss">
@import './assets/style.scss';
</style>
